import { action } from "easy-peasy";

const MapModel = {
  currentLocation: "",
  setLocation: action((state, payload) => {
    state.currentLocation = payload;
  }),
};
export default MapModel;
